module.exports = __webpack_public_path__ + "static/media/ico-mercadopago.5d79cadf.svg";